import { render, staticRenderFns } from "./pairs.vue?vue&type=template&id=cf01b992&scoped=true"
import script from "./pairs.vue?vue&type=script&lang=js"
export * from "./pairs.vue?vue&type=script&lang=js"
import style0 from "./pairs.vue?vue&type=style&index=0&id=cf01b992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf01b992",
  null
  
)

export default component.exports